import React, { useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { send } from "emailjs-com";
import html from "../EmailTemplate"; // your custom template
import { getEnvConfig } from "../utils/common"; // env config helper
import planeHero from "../planeHero.png";
import heroImage from "../heroImage.png";
import powered from "../powered.png";
import "./SignupForm.css";
import EarlyAccessCard from "./EarlyAccessCard";
import ModalPanel from "./ModalPanel";

const SignupHero = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
  });

  // Mobile detection state
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [content, setContent] = useState({
    title: 'Your Favorite Celebrity.Their Star Aura.',
    primaryDescription: '',
    secondaryTitle: '',
    secondaryDescription: '',
    backgroundImageUrl: '',
    heroImageUrl: ''
  });

  useEffect(() => {
    if (isModalOpen) {
      const scrollY = window.scrollY;
      const body = document.body;
      const originalPosition = body.style.position;
      const originalTop = body.style.top;
      const originalWidth = body.style.width;

      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.width = '100%';

      return () => {
        body.style.position = originalPosition;
        body.style.top = originalTop;
        body.style.width = originalWidth;
        window.scrollTo(0, scrollY);
      };
    }
  }, [isModalOpen]);

  const handleModalClose = () => setModalOpen(false);
  const handleModalOpen = () => setModalOpen(true);

  // ✅ Environment config
  const envConfig = getEnvConfig();
  const logoBase64 = `${envConfig.webUrl}emailHeader.png`;
  const logoBase = `${envConfig.webUrl}emailHeader.png`;
  const {
    emailConfigurations: { serviceId, userId, templateStarAura },
  } = envConfig;

  const sendEmail = async () => {
    try {
      await send(
        serviceId,
        templateStarAura,
        {
          html: html({ email: formData.email }, logoBase64, logoBase),
          to_email: formData.email,
        },
        userId
      );
      console.log("📧 Email sent successfully");
    } catch (error) {
      console.error("❌ Email sending failed:", error.text || error);
    }
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { fullname, email } = formData;

    if (!fullname || !email) {
      setErrorMsg("Please fill all fields.");
      return;
    }
    if (!isValidEmail(email)) {
      setErrorMsg("Please enter a valid email address.");
      return;
    }

    setErrorMsg("");
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000' : '');
      const response = await fetch(`${apiUrl}/api/contacts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          fullname,
          os: "",
          fund_name: "",
          is_active: "",
          message: "",
          phone_number: "",
          created_by: "",
          created_date: new Date().toISOString(),
          updated_by: "",
          updated_date: "",
          is_deleted: 0,
          type: "star_aura",
        }),
      });

      if (!response.ok) {
        throw new Error(`Server returned ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      console.log("✅ Contact saved to SQLite with ID:", result.id);

      await sendEmail();

      setSubmitted(true);
      // setTimeout(() => setSubmitted(false), 1000);

      setFormData({ fullname: "", email: "" });
    } catch (error) {
      console.error("❌ Error saving contact:", error);
      alert("❌ Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  const scrollIntoView = (inputId, buttonId = "signup-button") => {
    if (window.innerWidth > 768) return; // Skip on desktop

    const inputEl = document.getElementById(inputId);
    const buttonEl = document.getElementById(buttonId);

    if (inputEl) {
      setTimeout(() => {
        // Ensure the input is visible first
        inputEl.scrollIntoView({ behavior: "smooth", block: "center" });

        // Then, ensure the button is visible too
        if (buttonEl) {
          buttonEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }, 300); // delay to wait for keyboard resizing
    }
  };






  return (
    <>
      <div className="hero-wrapper">

        <div className="hero-inner hero-flex-responsive">
          <img src={heroImage} alt="Star Aura Hero"  className="hero-img" />
          <div className="hero-content-row">
            <div className="hero-overlay">
              <h2 className="experience-breaks">
                Experience <br className="mobile-br" />your favorite<br className="mobile-br" /> <br className="desktop-br" />
                celebrities in a<br className="mobile-br" /> whole<br className="desktop-br" />{" "}
                new way.<br className="mobile-br" />
              </h2>
              {/* Mobile only Request Early Access button */}
              {isMobile && (
                <button
                  className="request-access-mobile-btn"
                  style={{
                    width: '320px',
                    height: '60px',
                    margin: '12px 0',
                    padding: '12px',
                    borderRadius: '30px',
                    background: 'transparent',
                    color: '#fff',
                    fontWeight: 600,
                    marginTop: '20px',
                    fontFamily: 'Noto Sans',
                    fontSize: '16px',
                    border: '1px solid #FFFFFF',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    const card = document.querySelector('.early-access-card');
                    if (card) {
                      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                  }}
                >
                  Request Early Access
                </button>
              )}

              <p className="star-aura-subtext">
                Star Aura is the self-sovereign Personal AI of an artist, athlete, or creator, built and governed by them. It’s a persistent intelligence that carries forward their voice, perspective, and boundaries, allowing you to connect with who they are, not just what they post.
              </p>
                <ul className="star-aura-bullets">
                  <li>Interact with them in their real voice</li>
                  <li>Explore stories, insights, and perspectives shaped by their lived experience</li>
                  <li>Connect anytime through their persistent Personal AI</li>
                </ul>
                <p className="star-aura-subtext">Be among the first to experience Personal AI created and governed by the stars themselves.</p>

              <div className="form-scroll-container">
                {submitted ? (
                  <div className="success-container" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px' }}>
                    <FaCheckCircle style={{ color: "#C5FF00", fontSize: 40 }} />
                    <p className="success-text" style={{ color: "#C5FF00", fontSize: 18, fontWeight: 600 }}>Successfully Sent</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="signup-form">
                    {/* <label>Full Name</label>
                    <input
                      type="text"
                      name="fullname"
                      id="fullname-input"
                      value={formData.fullname}
                      onChange={handleChange}
                      required
                      onFocus={() => scrollIntoView('fullname-input')}
                    /> */}

                    {/* <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      id="email-input"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      onFocus={() => scrollIntoView('email-input')}
                    /> */}

                    {/* {errorMsg && (
                      <div style={{ color: "red", marginTop: 4, fontSize: 14 }}>
                        {errorMsg}
                      </div>
                    )} */}

                    <button
                      id="signup-button" 
                      onClick={handleModalOpen}
                    >
                     Learn more
                    </button>
                  </form>
                )}
              </div>
            </div>
            {/* EarlyAccessCard on right for desktop, below for mobile */}
            <div className="early-access-card-container">
              <EarlyAccessCard />
            </div>
          </div>
        </div>

        <p className="disclaimer">
          <strong>Disclaimer:</strong> Celebrity are used for illustrative
          purposes only and do not imply endorsement, affiliation, or
          participation.
        </p>
      </div>

      {/* Powered by */}
      <div className="powered-container">
        <img
          src={powered}
          alt="Star Aura Hero"
          className="powered-img"
        />
        <div className="powered-text">
          powered by
          <a
            href="https://rainfall.one/"
            target="_blank"
            rel="noopener noreferrer"
            className="powered-brand"
            style={{ textDecoration: "none" }}
          >
            <strong>Rainfall.</strong>
          </a>
        </div>
      </div>


      <ModalPanel
        open={isModalOpen}
        onClose={handleModalClose}
        secondaryTitle={content.secondaryTitle}
        secondaryDescription={content.secondaryDescription}
        
      />
    </>
  );
};

export default SignupHero;




